<h1 mat-dialog-title *ngIf="action===dialogActions.ADD">{{ 'material.addMaterial' | transloco }}</h1>
<h1 mat-dialog-title *ngIf="action===dialogActions.EDIT">{{ 'material.editMaterial' | transloco }}</h1>

<mat-dialog-content class="dialog-content">
  <app-relevant-calculation-selector [(relevantAnalysisTypes)]="relevantAnalysisTypes"/>
  <form [formGroup]="addEditMaterialForm">
    <div class="flex-container">
      <mat-card class="material-card">
        <mat-card-content class="inner-container">
          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.layer.tooltips.function' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.function' | transloco }}</mat-label>
            <mat-select formControlName="functionId">
              <mat-option *ngFor="let func of allMaterialFunctions" [value]="func.id">
                {{func.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formControls.functionId.errors">
              <span *ngIf="formControls.functionId.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.layer.tooltips.material' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.material' | transloco }}</mat-label>
            <mat-select formControlName="materialId">
              <mat-option [value]="null"> {{ 'common.text.noSelection' | transloco }}</mat-option>
              <mat-option *ngFor="let mat of validMaterials" [value]="mat.id">
                {{mat.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formControls.materialId.errors">
              <span *ngIf="formControls.materialId.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide" [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'materialManifestation')}"
            matTooltip="{{ 'material.layer.tooltips.manifestation' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.manifestation' | transloco }}</mat-label>
            <mat-select formControlName="materialManifestationId">
              <mat-option [value]="null"> {{ 'common.text.noSelection' | transloco }}</mat-option>
              <mat-option *ngFor="let manifestation of validManifestations" [value]="manifestation.id">
                {{manifestation.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formControls.materialManifestationId.errors">
              <span *ngIf="formControls.materialManifestationId.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide" [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'manufacturingType')}"
            matTooltip="{{ 'material.layer.tooltips.manufacturingType' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.manufacturingType' | transloco }}
            </mat-label>
            <mat-select formControlName="manufacturingTypeId">
              <mat-option [value]="null"> {{ 'common.text.noSelection' | transloco }}</mat-option>
              <mat-option *ngFor="let type of validManufacturingTypes" [value]="type.id">
                {{type.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formControls.manufacturingTypeId.errors">
              <span *ngIf="formControls.manufacturingTypeId.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field
            [class]="defaultRecyclatePercentage || !isRecyclateAllowed ? 'form-field-button-icon' : 'form-field-button'"
            [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'recyclingMaterialPercentage')}"
            matTooltip="{{ 'material.layer.tooltips.recyclatePercentage' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.recyclatePercentage' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="recyclatePercentage" min="0" max="100"
              autocomplete="off">
            <mat-error *ngIf="formControls.recyclatePercentage.errors">
              <span *ngIf="formControls.recyclatePercentage.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
              <span *ngIf="formControls.recyclatePercentage.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0%'} }}
              </span>
              <span *ngIf="formControls.recyclatePercentage.errors.max">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeGreaterThan' | transloco: {value: '100%'} }}
              </span>
            </mat-error>
          </mat-form-field>
          <button class="icon-right" mat-icon-button [disabled]="!isResetRecyclatDefaultValueAllowed()" (click)="resetRecyclatDefaultValue()" type="button"
            matTooltip="{{ 'material.layer.tooltips.resetRecyclate' | transloco: {percentage: getResetValue()} }}">
            <mat-icon>
              undo
            </mat-icon>
          </button>
          <mat-icon *ngIf="!isRecyclateAllowed && defaultRecyclatePercentage" class="icon-right"
            matTooltip="{{ 'material.layer.tooltips.recyclateNotAllowedDefaultAvailable' | transloco: {percentage: defaultRecyclatePercentage} }}">
            notifications_active
          </mat-icon>
          <mat-icon *ngIf="isRecyclateAllowed && defaultRecyclatePercentage" class="icon-right"
            matTooltip="{{ 'material.layer.tooltips.defaultRecyclatePercentage' | transloco: {percentage: defaultRecyclatePercentage} }}">
            notifications_active
          </mat-icon>
          <mat-icon *ngIf="!isRecyclateAllowed && !defaultRecyclatePercentage" class="icon-right"
            matTooltip="{{ 'material.layer.tooltips.recyclateNotAllowed' | transloco }}">
            notifications_active
          </mat-icon>

          <mat-form-field class="form-field-wide" [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'color')}"
            matTooltip="{{ 'material.layer.tooltips.color' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.color' | transloco }}</mat-label>
            <mat-select formControlName="colorId">
              <mat-option *ngFor="let color of validColors" [value]="color.id">
                {{color.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formControls.colorId.errors">
              <span *ngIf="formControls.colorId.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <mat-card class="material-card">
        <mat-card-content class="inner-container">
          <mat-form-field class="form-field-wide"
            [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'materialOrigin')}"
            matTooltip="{{ 'material.layer.tooltips.originCountry' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.originCountry' | transloco }}
            </mat-label>
            <mat-select formControlName="materialOriginCountryCode">
              <mat-option>{{ 'common.text.noSelection' | transloco }}</mat-option>
              <mat-option *ngFor="let country of handler.manufacturingCountries" [value]="country.code">
                {{country.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.layer.tooltips.grammage' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.grammage' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="grammage" min="0.001" autocomplete="off">
            <mat-error *ngIf="formControls.grammage.errors">
              <span *ngIf="formControls.grammage.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0,001'} }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.layer.tooltips.thickness' | transloco }}">
            <mat-label class="label-large">
              {{ 'material.layer.thickness' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="thickness" min="0.001" autocomplete="off">
            <mat-error *ngIf="formControls.thickness.errors">
              <span *ngIf="formControls.thickness.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0,001'} }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'density')}"
            matTooltip="{{ 'material.layer.tooltips.density' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.density' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="density" min="0.001" autocomplete="off">
            <mat-error *ngIf="formControls.density.errors">
              <span *ngIf="formControls.density.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0,001'} }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide"
            matTooltip="{{ 'material.layer.tooltips.percentage' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.percentage' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="massPercentage" min="0" max="100" autocomplete="off">
            <mat-error *ngIf="formControls.massPercentage.errors">
              <span *ngIf="formControls.massPercentage.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0%'} }}
              </span>
              <span *ngIf="formControls.massPercentage.errors.max">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeGreaterThan' | transloco: {value: '100%'} }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field-wide" [ngClass]="{'calcRelevant': RelevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.Material,'mass')}"
            matTooltip="{{ 'material.layer.tooltips.mass' | transloco }}">
            <mat-label class="label-large">{{ 'material.layer.mass' | transloco }}
            </mat-label>
            <input matInput type="number" formControlName="mass" autocomplete="off">
            <mat-error *ngIf="formControls.mass.errors">
              <span *ngIf="formControls.mass.errors.required">
                {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
              </span>
              <span *ngIf="formControls.mass.errors.min">
                {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value: '0,001'} }}
              </span>
            </mat-error>
          </mat-form-field>

          <div>
            {{ 'material.layer.massCalculator.calculateLabel' | transloco }}
            <button mat-raised-button *ngIf="!showCalculator; else closeCalculator" (click)="toggleCalculator()"
              [disabled]="!isWeightAllowed || !canEditForm" color="primary" type="button">
              {{ 'material.layer.massCalculator.openCalculatorButton' | transloco }}
              <mat-icon>arrow_right</mat-icon>
            </button>
            <ng-template #closeCalculator>
              <button mat-raised-button (click)="toggleCalculator()"
                [disabled]="!isWeightAllowed || !canEditForm" color="primary" type="button">
                <mat-icon>arrow_left</mat-icon>
                {{ 'material.layer.massCalculator.closeCalculatorButton' | transloco }}
              </button>
            </ng-template>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="material-card" *ngIf="showCalculator">
        <mat-card-content class="inner-container">
          <app-mass-calculator [totalWeight]="totalWeight"
            [calculatorTotalWeight]="calculatorTotalWeight" [totalGrammage]="totalGrammage"
            [layerGrammage]="formControls.grammage.value" [layerThickness]="formControls.thickness.value"
            [layerDensity]="formControls.density.value" [layerPercentage]="formControls.massPercentage.value"
            [callerId]="callerId" (layerMassCalculated)="layerMassCalculated($event)"
            (calculatorTotalMassChange)="calculatorTotalMassChanged($event)"
            (calculatorLayerGrammageChange)="calculatorLayerGrammageChanged($event)"
            (calculatorLayerThicknessChange)="calculatorLayerThicknessChanged($event)"
            (calculatorLayerDensityChange)="calculatorLayerDensityChange($event)"
            (calculatorLayerPercentageChange)="calculatorLayerPercentageChange($event)">
          </app-mass-calculator>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card *ngIf="allLayersTableDataSource.data.length > 0" class="full-width">
      <mat-card-header>
        <mat-card-title>
          <h5>{{ 'material.layersTableHeader' | transloco }}</h5>
        </mat-card-title>
      </mat-card-header>
      <app-material-layers-view [dataSource]="allLayersTableDataSource"></app-material-layers-view>
    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button *ngIf="action===dialogActions.ADD" (click)="doAction()" mat-raised-button type="submit" color="primary">
    {{ 'common.buttons.add' | transloco }}</button>
  <button *ngIf="action===dialogActions.EDIT" (click)="doAction()" mat-raised-button type="submit" color="primary"
    [disabled]="!canEditForm">{{ 'common.buttons.save' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
